import { createFileRoute } from "@tanstack/react-router";

import { PageTitle } from "@/components/PageTitle";

export const Route = createFileRoute("/$organizationKey/$dossierId/outcome/$questionnaireId/help")({
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <>
      <PageTitle title="outcomeHelp" />
      <div>Hello "/$organizationKey/$dossierId/outcome/$questionnaireId/help"!</div>
    </>
  );
}
